import { useTRPC } from "../trpc/client";
import { useQuery, useMutation } from "@tanstack/react-query";

interface UseRatingProps {
  onSuccess?: () => void;
  onError?: (error: unknown) => void;
}

export function useRating({ onSuccess, onError }: UseRatingProps = {}) {
  const trpc = useTRPC();
  
  const shouldShowRatingModalQuery = useQuery(
    trpc.ratings.shouldShowRatingModal.queryOptions(undefined)
  );

  const createRating = useMutation({
    ...trpc.ratings.create.mutationOptions(),
    onSuccess,
    onError,
  });

  return {
    shouldShowRatingModal: shouldShowRatingModalQuery.data,
    createRating: createRating.mutateAsync,
    isRatingCreationLoading: createRating.isPending,
  };
}
